export default "__VITE_ASSET__CWpFSoOq__"